import React from 'react'
import { navigate } from '@reach/router'

function Primarybutton({
  buttonType,
  buttonText,
  buttonLink = 'https://app.magictask.io',
  customClass,
  noHover,
  openInNewTab = true,
  onClick,
  buttonId = ''
}) {
  const handleOnClick = () => {
    if (
      openInNewTab &&
      typeof window !== 'undefined' &&
      buttonLink !== '' &&
      buttonLink !== '/'
    ) {
      window.open(buttonLink, '_blank')
    } else {
      navigate(buttonLink)
    }
  }

  return (
    <button
      id={buttonId}
      className={`btn primarybutton--${buttonType ? buttonType : 'filled'}
    primarybutton  ${noHover && 'primarybutton--noHover'}  ${
        customClass || ''
      }`}
      onClick={onClick || handleOnClick}
    >
      {buttonText}
    </button>
  )
}

export default Primarybutton
